/**
 * Relation fields hold full story objects only when the field is listed in
 * resolve_relations and the linked story is published - otherwise Storyblok
 * returns the bare UUID string.
 */
export function isResolvedStory<T extends { content: unknown }>(
    item: T | string | null | undefined
): item is T {
    return typeof item === 'object' && item != null && 'content' in item;
}
